import ApiFactory from '@/factories/ApiFactory'
import store from '../store/store';

export default {
  me () {
    return new Promise((resolve, reject) => {
      ApiFactory.get('v1/me?include=roles')
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  login (user) {
    return new Promise((resolve, reject) => {
      ApiFactory.post('v1/login', user)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  updateProfile (user) {
    return new Promise((resolve, reject) => {
      ApiFactory.post('v1/updateProfile', user)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  changePassword (data) {
    return new Promise((resolve, reject) => {
      ApiFactory.post('v1/changePassword', data)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  logout () {
    return new Promise((resolve, reject) => {
      ApiFactory.post('v1/logout')
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  hasOneOfRoles: (roles) => {
    const userData = store.state.me;
    return userData && userData.roles && userData.roles.filter(x => roles.indexOf(x.name) > -1).length > 0;
  },
}
